"use strict";
/*
 * Created on 3. 4. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils");
/**
 * Input data for bulk updates of release items.
 * @author Radek Beran
 * @author Jan Prokop
 */


var SelloutReleaseItemUpdate = function SelloutReleaseItemUpdate() {
  _classCallCheck(this, SelloutReleaseItemUpdate);
};

exports.SelloutReleaseItemUpdate = SelloutReleaseItemUpdate; // tslint:disable:max-classes-per-file

var FinalPriceItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp) {
  _inherits(FinalPriceItemUpdate, _SelloutReleaseItemUp);

  function FinalPriceItemUpdate(finalPriceValue) {
    var _this;

    _classCallCheck(this, FinalPriceItemUpdate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FinalPriceItemUpdate).call(this));
    _this.finalPriceValue = finalPriceValue;
    _this.tag = FinalPriceItemUpdate.TAG;
    return _this;
  }

  _createClass(FinalPriceItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.finalPriceValue.equals(other.finalPriceValue);
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.finalPriceValue.toString());
    }
  }]);

  return FinalPriceItemUpdate;
}(SelloutReleaseItemUpdate);

exports.FinalPriceItemUpdate = FinalPriceItemUpdate;
FinalPriceItemUpdate.TAG = 'finalPrice';

var EndDateItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp2) {
  _inherits(EndDateItemUpdate, _SelloutReleaseItemUp2);

  function EndDateItemUpdate(endDate) {
    var _this2;

    _classCallCheck(this, EndDateItemUpdate);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(EndDateItemUpdate).call(this));
    _this2.endDate = endDate;
    _this2.tag = EndDateItemUpdate.TAG;
    return _this2;
  }

  _createClass(EndDateItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.endDate === null && other.endDate === null || this.endDate !== null && other.endDate !== null && this.endDate.isSame(other.endDate);
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.endDate ? this.endDate.toISOString() : '');
    }
  }]);

  return EndDateItemUpdate;
}(SelloutReleaseItemUpdate);

exports.EndDateItemUpdate = EndDateItemUpdate;
EndDateItemUpdate.TAG = 'endDate';

var PriceCodeItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp3) {
  _inherits(PriceCodeItemUpdate, _SelloutReleaseItemUp3);

  function PriceCodeItemUpdate(priceCode) {
    var _this3;

    _classCallCheck(this, PriceCodeItemUpdate);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PriceCodeItemUpdate).call(this));
    _this3.priceCode = priceCode;
    _this3.tag = PriceCodeItemUpdate.TAG;
    return _this3;
  }

  _createClass(PriceCodeItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.priceCode === other.priceCode;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.priceCode || '');
    }
  }]);

  return PriceCodeItemUpdate;
}(SelloutReleaseItemUpdate);

exports.PriceCodeItemUpdate = PriceCodeItemUpdate;
PriceCodeItemUpdate.TAG = 'priceCode';

var MinPriceChangeItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp4) {
  _inherits(MinPriceChangeItemUpdate, _SelloutReleaseItemUp4);

  function MinPriceChangeItemUpdate(minPriceChangeInPercent) {
    var _this4;

    _classCallCheck(this, MinPriceChangeItemUpdate);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(MinPriceChangeItemUpdate).call(this));
    _this4.minPriceChangeInPercent = minPriceChangeInPercent;
    _this4.tag = MinPriceChangeItemUpdate.TAG;
    return _this4;
  }

  _createClass(MinPriceChangeItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.minPriceChangeInPercent === null && other.minPriceChangeInPercent === null || this.minPriceChangeInPercent !== null && other.minPriceChangeInPercent !== null && this.minPriceChangeInPercent.equals(other.minPriceChangeInPercent);
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.minPriceChangeInPercent ? this.minPriceChangeInPercent.toString() : '');
    }
  }]);

  return MinPriceChangeItemUpdate;
}(SelloutReleaseItemUpdate);

exports.MinPriceChangeItemUpdate = MinPriceChangeItemUpdate;
MinPriceChangeItemUpdate.TAG = 'minPriceChange';

var MaxPriceChangeItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp5) {
  _inherits(MaxPriceChangeItemUpdate, _SelloutReleaseItemUp5);

  function MaxPriceChangeItemUpdate(maxPriceChangeInPercent) {
    var _this5;

    _classCallCheck(this, MaxPriceChangeItemUpdate);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(MaxPriceChangeItemUpdate).call(this));
    _this5.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this5.tag = MaxPriceChangeItemUpdate.TAG;
    return _this5;
  }

  _createClass(MaxPriceChangeItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.maxPriceChangeInPercent === null && other.maxPriceChangeInPercent === null || this.maxPriceChangeInPercent !== null && other.maxPriceChangeInPercent !== null && this.maxPriceChangeInPercent.equals(other.maxPriceChangeInPercent);
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.maxPriceChangeInPercent ? this.maxPriceChangeInPercent.toString() : '');
    }
  }]);

  return MaxPriceChangeItemUpdate;
}(SelloutReleaseItemUpdate);

exports.MaxPriceChangeItemUpdate = MaxPriceChangeItemUpdate;
MaxPriceChangeItemUpdate.TAG = 'maxPriceChange';

var MinMarginChangeItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp6) {
  _inherits(MinMarginChangeItemUpdate, _SelloutReleaseItemUp6);

  function MinMarginChangeItemUpdate(minMarginChangeInPercent) {
    var _this6;

    _classCallCheck(this, MinMarginChangeItemUpdate);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(MinMarginChangeItemUpdate).call(this));
    _this6.minMarginChangeInPercent = minMarginChangeInPercent;
    _this6.tag = MinMarginChangeItemUpdate.TAG;
    return _this6;
  }

  _createClass(MinMarginChangeItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.minMarginChangeInPercent === null && other.minMarginChangeInPercent === null || this.minMarginChangeInPercent !== null && other.minMarginChangeInPercent !== null && this.minMarginChangeInPercent.equals(other.minMarginChangeInPercent);
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.minMarginChangeInPercent ? this.minMarginChangeInPercent.toString() : '');
    }
  }]);

  return MinMarginChangeItemUpdate;
}(SelloutReleaseItemUpdate);

exports.MinMarginChangeItemUpdate = MinMarginChangeItemUpdate;
MinMarginChangeItemUpdate.TAG = 'minMarginChange';

var CommentItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp7) {
  _inherits(CommentItemUpdate, _SelloutReleaseItemUp7);

  function CommentItemUpdate(comment) {
    var _this7;

    _classCallCheck(this, CommentItemUpdate);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(CommentItemUpdate).call(this));
    _this7.comment = comment;
    _this7.tag = CommentItemUpdate.TAG;
    return _this7;
  }

  _createClass(CommentItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.comment === other.priceCode;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.comment);
    }
  }]);

  return CommentItemUpdate;
}(SelloutReleaseItemUpdate);

exports.CommentItemUpdate = CommentItemUpdate;
CommentItemUpdate.TAG = 'comment';

var ExportedItemUpdate =
/*#__PURE__*/
function (_SelloutReleaseItemUp8) {
  _inherits(ExportedItemUpdate, _SelloutReleaseItemUp8);

  function ExportedItemUpdate(exported) {
    var _this8;

    _classCallCheck(this, ExportedItemUpdate);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ExportedItemUpdate).call(this));
    _this8.exported = exported;
    _this8.tag = ExportedItemUpdate.TAG;
    return _this8;
  }

  _createClass(ExportedItemUpdate, [{
    key: "equals",
    value: function equals(other) {
      return this.exported === other.priceCode;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.exported.toString());
    }
  }]);

  return ExportedItemUpdate;
}(SelloutReleaseItemUpdate);

exports.ExportedItemUpdate = ExportedItemUpdate;
ExportedItemUpdate.TAG = 'exported';